module.exports = __webpack_public_path__ + "img/Group 21.7e4b9995.svg";